import React from "react"
import { Footer } from "@/pages/Footer"
import NavBar from "./navBar/NavBar"
import { Outlet, useLocation } from "react-router-dom"
import { NavBarProvider } from "@/contexts/NavBarContext"
import ReactGA from "react-ga4"
import { useEffect } from "react"

const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname })
  }, [location])
}

const Layout = () => {
  usePageTracking()
  return (
    <div
      className="container"
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <NavBarProvider>
        <NavBar />
      </NavBarProvider>
      <main
        style={{
          flex: 1,
          background: "#f0f0f0",
          // paddingBottom: "42px",
        }}
      >
        <Outlet />
      </main>

      <Footer />
    </div>
  )
}

export default Layout